// Living in Nepal hub — SIM, money, apps, etiquette, day-to-day practical knowledge
import { EXPLORE_IMAGES } from './exploreImages';
import { OFFICIAL_SOURCES, LAST_VERIFIED } from './officialSources';

export const LIVING_HUB = {
	title: 'Living in Nepal — Day-to-Day Guide',
	eyebrow: 'Travel Lifecycle · Daily Life',
	hero: EXPLORE_IMAGES.valley,
	lastVerified: LAST_VERIFIED,
	quickFacts: [
		{ value: 'NTC / Ncell', label: 'Mobile networks' },
		{ value: 'Pathao', label: 'Ride app (KTM/Pokhara)' },
		{ value: 'NPR', label: 'Cash for daily life' },
		{ value: '220V', label: 'Type C/D plugs' },
	],
	lead: 'Everything you need after landing — SIM card, money, apps, etiquette, and how to not feel like a confused outsider on day two.',
	sections: [
		{
			id: 'sim',
			question: 'Getting a SIM card',
			source: OFFICIAL_SOURCES.ntc,
			answer: 'NTC and Ncell sell tourist prepaid SIMs at Tribhuvan Airport and in Thamel/Lakeside. Passport and photo required for registration. Ncell: faster urban data. NTC: better rural/trekking coverage. Typical tourist pack: 7–30 days with 5–20GB. Recharge at shops displaying operator logos.',
			tips: ['Buy SIM before leaving airport if you need Pathao immediately.', 'NT eSIM at esim.ntc.net.np for compatible phones.'],
		},
		{
			id: 'money',
			question: 'Money, ATMs, and cards',
			answer: 'Nepali Rupee (NPR) for daily spending. ATMs in cities dispense NPR — notify your bank before travel. Cards work at major hotels and some Thamel shops (3–4% surcharge). Trekking trails are cash-only — withdraw enough in Kathmandu or Pokhara before leaving.',
			tips: ['Nabil and Himalayan Bank ATMs widely accept foreign cards.', 'Carry USD for visa; NPR for everything else.'],
		},
		{
			id: 'apps',
			question: 'Apps to download',
			answer: 'Pathao and inDrive for rides in Kathmandu and Pokhara. Google Maps (download offline Nepal maps). Maps.me or Gaia GPS for trekking. WhatsApp ubiquitous for communicating with guides and hotels. Khalti/eSewa for local digital payments — less useful for short tourist visits.',
			tips: ['Pathao needs local SIM for OTP.', 'Offline maps essential — signal drops on trails.'],
		},
		{
			id: 'etiquette',
			question: 'Cultural etiquette',
			answer: 'Remove shoes before entering homes and temple inner areas. Walk clockwise around Buddhist stupas and chortens. Do not point feet at people or religious objects. Ask before photographing people — especially sadhus and ceremonies. Right hand for giving/receiving. "Namaste" with palms together is universal greeting.',
			tips: ['Dress modestly at temples — cover shoulders and knees.', 'Do not touch someone\'s head — considered sacred.'],
		},
		{
			id: 'electricity',
			question: 'Power and charging',
			answer: '220V, 50Hz. Type C, D, and M plugs common — bring universal adapter. Power cuts (load shedding) less frequent in tourist areas than before, but still occur. Teahouses charge NPR 200–500 for device charging on treks.',
			tips: ['Portable battery essential for trekking.', 'Surge protector useful in monsoon season.'],
		},
		{
			id: 'language',
			question: 'Languages spoken',
			answer: 'Nepali is the official language. English widely spoken in Thamel, Lakeside, trekking routes, and by younger Nepalis in cities. Hindi understood in Terai. Learning "Dhanyabad" (thank you) and "Namaste" goes far.',
			tips: ['Trekking guides speak functional English.', 'Google Translate works offline if you download Nepali.'],
		},
		{
			id: 'connectivity',
			question: 'Internet and WiFi',
			answer: 'Hotels and cafes in Kathmandu and Pokhara have WiFi — quality varies. NT WiFi hotspots at airport and some public areas (text WIFI10 to 1416). Trekking lodge WiFi slow and intermittent. Do not rely on connectivity above Namche Bazaar.',
			source: OFFICIAL_SOURCES.ntc,
			tips: ['Buy data package rather than pay-per-MB.', 'VPN legal but rarely needed.'],
		},
	],
	faqs: [
		{ q: 'Can I drink the tap water?', a: 'No — bottled, boiled, or filtered only.' },
		{ q: 'Is Nepal LGBTQ+ friendly?', a: 'Nepal recognizes third gender legally and is relatively progressive in South Asian context, but public displays of affection are uncommon everywhere. Exercise discretion in rural areas.' },
		{ q: 'What about laundry?', a: 'Hotels and guesthouses offer laundry. Thamel has cheap per-kilo services. On treks, wash in cold stream water or pay teahouse.' },
		{ q: 'Tipping culture?', a: 'Restaurants: round up. Trekking guides/porters: tip at end (USD 50–150+ per guide for multi-day trek). Taxis: round up.' },
	],
	related: [
		{ label: 'Airport arrival', to: '/arrival' },
		{ label: 'SIM guide', to: '/plan/sim' },
		{ label: 'ATM & money', to: '/plan/atm' },
		{ label: 'Safety & emergency', to: '/safety' },
		{ label: 'Scams to avoid', to: '/guides/common-tourist-scams-how-to-avoid-them' },
	],
};
